import { CloseIcon } from "../../../assets/icons"
import cx from "classnames"
import { useState } from "react"

import type { CheckboxProps } from "../form/checkbox"
import type { InfoCardVariant } from "./types"

import { Button } from "../button"
import { Checkbox } from "../form/checkbox"
import { VARIANT_CONFIG } from "./config"
import styles from "./index.module.css"
import { INFO_CARD_ICONS } from "./types"

export type InfoCardProps = {
  variant: InfoCardVariant
  message: React.ReactNode
  title?: string
  dismissable?: boolean
  onDismiss?: () => void
  checkbox?: CheckboxProps & { label: string }
  cta?: {
    label: string
    isLoading?: boolean
    onClick: () => void
  }
}

export const InfoCard = ({
  variant,
  title,
  message,
  dismissable = true,
  onDismiss,
  cta,
  checkbox,
}: InfoCardProps): React.JSX.Element => {
  const [isVisble, setIsVisible] = useState(true)
  const infoCardClasses = cx(styles[variant], styles.infoCardContainer, {
    [styles.hidden]: !isVisble,
  })

  const { buttonColor, checkboxColor } = VARIANT_CONFIG[variant]

  return (
    <div className={styles.infoCardWrapper}>
      <div className={infoCardClasses}>
        <span className={styles.infoCardIconContainer}>
          <span className={styles.icon}>{INFO_CARD_ICONS[variant]()}</span>
        </span>
        <div className={styles.infoCardContent}>
          <div className={styles.infoCardContentText}>
            {title && <h2 className={styles.infoCardContentTitle}>{title}</h2>}
            <p className={styles.infoCardContentDescription}>{message}</p>
          </div>
          <div className={styles.infoCardContentControls}>
            {checkbox && <Checkbox {...checkbox} variant={checkboxColor} label={checkbox.label} />}
            {cta && (
              <div className={styles.infoCardContentButtonContainer}>
                <Button onClick={cta.onClick} isLoading={cta.isLoading} size="medium" isFull color={buttonColor}>
                  {cta.label}
                </Button>
              </div>
            )}
          </div>
        </div>
        {dismissable && (
          <button
            className={styles.closeIconContainer}
            onClick={() => {
              setIsVisible((prev) => !prev)
              onDismiss?.()
            }}
          >
            <span className={styles.icon}>
              <CloseIcon />
            </span>
          </button>
        )}
      </div>
    </div>
  )
}
